// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.account_block div + div[data-v-3e998503] {\n    border-left: 1px solid #959ba450;\n}\n@media screen and (max-width: 992px) {\n.account_block div + div[data-v-3e998503] {\n        border-top: 1px solid var(--grey-color);\n        border-left: none;\n}\n}\n", ""]);
// Exports
module.exports = exports;
